// Aguarda o DOM ser carregado para garantir que todos os elementos existam
document.addEventListener('DOMContentLoaded', function () {

  // Encontra o container principal que agora tem a nossa variável
  const container = document.getElementById('merge-lead-container');

  // Adiciona uma verificação para só executar o código se o container existir na página
  if (container) {
    // Seleciona os outros elementos
    const targetSelect = document.getElementById('target_origin_select');
    const submitButton = document.getElementById('submit-button');

    // Lê o nome da origem a partir do atributo data-* do container
    // .dataset.sourceOriginName é a forma como o JS lê 'data-source-origin-name'
    const sourceOriginName = container.dataset.sourceOriginName;

    // Adiciona um ouvinte de eventos para o campo de seleção
    targetSelect.addEventListener('change', function () {
      if (this.value) {
        submitButton.disabled = false;

        const selectedOptionText = this.options[this.selectedIndex].text;
        // Agora usa a variável 'sourceOriginName' que lemos do HTML
        const newConfirmMessage = `Migrar os Leads de <strong>${sourceOriginName}</strong> para <strong>${selectedOptionText}</strong>?`;
        submitButton.setAttribute('data-confirm', newConfirmMessage);

      } else {
        submitButton.disabled = true;
        submitButton.setAttribute('data-confirm', 'Selecione uma origem de destino.');
      }
    });
  }
});